import { useState, useEffect, useCallback } from 'react';

export const useIntersectionObserver = (
	onIntersection: () => void,
): ((node: Element | null) => void) => {
	const [ref, setRef] = useState<Element | null>(null);

	const handleObserver: IntersectionObserverCallback = useCallback(
		(entries) => {
			entries.forEach(({ isIntersecting }) => {
				if (isIntersecting) {
					onIntersection();
				}
			});
		},
		[onIntersection],
	);

	useEffect(() => {
		if (!ref || __SERVER__) {
			return undefined;
		}

		const observer = new IntersectionObserver(handleObserver, {
			root: null,
			rootMargin: '20px',
			threshold: 0,
		});

		if (ref) {
			observer.observe(ref);
		}

		return () => {
			observer.disconnect();
		};
	}, [ref, onIntersection, handleObserver]);

	return setRef;
};
